export const tenantTheme = {
  branding: {
    appName: 'Webtika',
    appSubtitle: 'Area riservata',
    appMark: 'W',
    clientName: 'Cliente',
    clientSubtitle: 'Area riservata',
    clientMark: 'C',
    supportEmail: 'supporto@webtika.it',
  },
  labels: {
    supportLabel: 'Hai bisogno di supporto operativo?',
    supportCta: 'Contatta un operatore',
  },
  theme: {
    modeStorageKey: 'app-theme-mode',
  },
};
